// extracted by mini-css-extract-plugin
export default {"paper":"AppTableFilterPopover_paper__rVE4w"};